//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  LANGUAGE,
} from "../../../store/mutation-types";
import MulConfirm from "../../confirm/Mul";
// import { dateFormat } from '../../../utils/plugin_helper'

export default {
  name: "UnlimitedAutoPostListComponent",
  components: { MulConfirm, HiCell },
  data() {
    const _this = this;
    return {
      showLockMenu: false,
      lockText: "",
      buttons: [
        {
          text: _this.$t("common.upgrade"),
          async click() {
            _this.$router.push({
              name: "PaymentUpgradePage",
              params: { type: "filter" },
            });
            return true;
          },
        },
        {
          text: _this.$t("common.contactUs"),
          async click() {
            window.open(process.env.CONTACT_US, "_blank");
            return true;
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      language: LANGUAGE,
    }),
    title() {
      let title = this.$t("myPlanPage.unlimitedInfo.title");
      return title;
    },
    insInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) =>
          l.isUnlimited &&
          !l.isMember &&
          l.status !== 2 &&
          l.socialNetwork === 1
      );
      return `${unlimitedPublishers.length}/${this.user.plan.premiumInstagramPublisherCount}`;
    },
    fbInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && (l.socialNetwork === 2 || l.socialNetwork === 3)
      );
      if (this.user.plan.premiumFacebookPublisherCount === 32767) {
        return `Unlimited`;
      }
      return `${unlimitedPublishers.length}/${this.user.plan.premiumFacebookPublisherCount}`;
    },
    twInfo() {
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && l.socialNetwork === 4
      );
      if (this.user.plan.premiumTwitterPublisherCount === 32767) {
        return `Unlimited`;
      }
      return `${unlimitedPublishers.length}/${this.user.plan.premiumTwitterPublisherCount}`;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    unlimitedUsers() {
      // 根据类型进行分组(只保留unlimited)
      const users = this.user.linkedInstagramList
        .filter((l) => l.isUnlimited && !l.isMember)
        .map((l) => {
          return {
            image: l.image,
            username: l.username,
            socialNetwork: l.socialNetwork,
          };
        });
      console.log("users", users);
      return users;
    },
    /**
     * 计算unlimited最大数量
     */
    maxUnlimitedAutoPostNum() {
      return (
        this.user.plan.premiumInstagramPublisherCount +
        this.user.plan.premiumFacebookPublisherCount
      );
    },
    /**
     * 计算最大展示数量
     */
    maxShowNum() {
      return this.maxUnlimitedAutoPostNum > 10 ? 9 : this.unlimitedUsers.length;
    },
  },
  methods: {
    /**
     * 修改用户
     */
    modifyUser() {
      // 如果unlimited用户数量为0 点击之后无效果
      if (this.unlimitedUsers.length === 0) {
        return;
      }
      this.$router.push({ name: "ModifyAutoPostPage" });
    },
    /**
     * 添加用户
     */
    async addUser() {
      // 2018-9-30 判断如果是免费用户直接进入选人页面
      if (this.user.plan.price === 0) {
        this.$router.push({ name: "AddAutoPostPage" });
        return;
      }
      // 2018-7-13 如果用户存在至少1个老账号，则可以直接进入添加页面 忘了为毛加了这么一个逻辑
      // if (this.user.linkedInstagramList.find(l => l.wasPremium)) {
      //   this.$router.push({ name: 'AddAutoPostPage' })
      //   return
      // }
      // 获取当前所有限制用户数量
      const limitedUserNum = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember && l.status === 1
      ).length;
      // 判断当前用户添加unlimited 用户是否已经达到上限
      if (
        this.user.premiumInstagramRemaining === 0 &&
        this.user.premiumFacebookRemaining === 0 &&
        this.user.premiumTwitterRemaining === 0
      ) {
        // // 用户在从未删除1个unlimited用户的前提下达到上限，则提示升级
        // if (this.unlimitedUsers.length === this.maxUnlimitedAutoPostNum) {
        // 获取国际化升级按钮和文案
        const upgradeBtnText = this.$t("common.upgrade");
        const upgradeText = this.$t("myPlanPage.unlimitedInfo.upgradeText");
        await this.$confirm.show({
          text: upgradeText,
          yesText: upgradeBtnText,
        });
        this.$router.push({
          name: "PaymentUpgradePage",
          params: { type: "filter" },
        });
        // } else {
        //   // 获取国际化30天升级提示
        //   const dayLimitedText = this.$t('addUnlimitedAccountPage.dayLimitedText', {
        //     date: dateFormat({ date: this.user.plan.nextStartTime, format: 'MMMM D, YYYY' })
        //   })
        //   this.lockText = dayLimitedText
        //   this.showLockMenu = true
        // }
      } else if (limitedUserNum === 0) {
        // 如果一个可添加用户都不存在则弹出该提示
        await this.$confirm.show({
          text: this.$t("inviteMemberPage.isInsNulText"),
          yesText: this.$t("common.add"),
        });
        // this.$router.push({ name: 'LoginInstagramPage' })
      } else {
        this.$router.push({ name: "AddAutoPostPage" });
      }
    },
  },
  activated() {
    console.log("unlimited activated", this.user);
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/unlimited_autopost_list/Index.vue